import { render, staticRenderFns } from "./LvBreadCrumb.vue?vue&type=template&id=c4f56766"
import script from "./LvBreadCrumb.vue?vue&type=script&lang=js"
export * from "./LvBreadCrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports